const excludedProducts = ["ILNn1nRWWWn3n12", "PHAn1nRWWWn3n6"];

async function handleToggle() {
  /* ============================================================= */
  /* ============================================================= */
  /* =================== Multi-address cart ====================== */
  /* ============================================================= */
  /* ============================================================= */
  // Deactivated toggle cart
  const deactivatedToggle = document.querySelector(
    "#gsGroups .gs__row:first-child",
  );

  if (deactivatedToggle != null) {
    // Page title
    const title = document.createElement("div");
    title.classList.add("pt-5");
    title.innerHTML =
      '<div class="title-wrapper-with-link" id="header-item-count"><h1 class="title title--primary">Votre panier</h1></div>';
    deactivatedToggle.insertAdjacentElement("afterend", title);
    document.body.style.fontSize = "16px";

    // Change notice first content
    deactivatedToggle.classList.add("color-background-2", "overflow-hidden");
    let notice =
      '<div class="toggle-action p-5 d-flex align-items-center justify-content-between gap-4" style="cursor: pointer;">';
    notice +=
      '<div class="d-flex align-items-center justify-content-start gap-4">';
    notice +=
      '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-truck-icon lucide-truck"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';
    notice += '<h2 class="mb-0">Panier à adresses multiples activé</h2>';
    notice += "</div>";
    notice += '<div class="d-flex align-items-center gap-4">';
    notice +=
      '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-icon lucide-circle-check"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>';
    notice +=
      '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>';
    notice += "</div>";
    notice += "</div>";
    deactivatedToggle.querySelector(".gs__fields").classList.add("d-block");
    deactivatedToggle
      .querySelector(".gs__fields")
      .insertAdjacentHTML("afterbegin", notice);

    // Change dropdown content
    deactivatedToggle.querySelector(".gs__field").style.maxHeight = "0";
    const box = document.getElementById("gs__toggle-box");
    box.classList.add("text-black", "bg-transparent", "pt-0", "px-5", "pb-5");
    const boxLabel = document.querySelector("#gs__toggle-box label");
    boxLabel.classList.add("float-none", "text-decoration-underline");
    boxLabel.innerHTML = "cliquer ici";

    const boxParagraph = document.querySelector("#gs__toggle-box > p");
    let before = "Veuillez ";
    boxParagraph.insertAdjacentHTML("afterbegin", before);
    let after = " pour désactiver cette option.";
    boxParagraph.insertAdjacentHTML("beforeend", after);

    // Dropdown handle
    deactivatedToggle
      .querySelector(".gs__fields .toggle-action")
      .addEventListener("click", () => {
        if (
          deactivatedToggle.querySelector(".gs__field").style.maxHeight == "0px"
        ) {
          deactivatedToggle.querySelector(".gs__field").style.maxHeight =
            "250px";
          deactivatedToggle.querySelector(
            ".lucide-chevron-down-icon",
          ).style.transform = "rotate(180deg)";
        } else {
          deactivatedToggle.querySelector(".gs__field").style.maxHeight = "0";
          deactivatedToggle.querySelector(
            ".lucide-chevron-down-icon",
          ).style.transform = "rotate(0)";
        }
      });

    // Process to do with what's in the cart
    fetch("/cart.json")
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const cart = JSON.parse(state);
        var hasBundles = false;
        var hasExcludedProducts = false;

        // Looking for bundles
        cart.items.forEach((item) => {
          if (item.properties != null && item.properties._bundleParentId) {
            hasBundles = true;
          }

          if (excludedProducts.includes(item.sku)) {
            hasExcludedProducts = true;
          }
        });

        if (hasBundles || hasExcludedProducts) window.location.href = "/cart";
        var hasAlreadyChanged = false;

        setInterval(() => {
          // Message for numeric products
          cart.items.forEach((item) => {
            if (!item.requires_shipping) {
              const variants = document.querySelectorAll(
                `[data-variantid="${item.variant_id}"]`,
              );

              variants.forEach((variant) => {
                if (variant.nextElementSibling == null) {
                  var digitalWarning =
                    "Cet article ne nécessite pas d'expédition, parce qu'il n'est pas physique.";

                  if (
                    variant.parentElement.querySelectorAll(".gs__line").length >
                    1
                  ) {
                    var digitalWarning =
                      "Ces articles ne nécessitent pas d'expédition, parce qu'ils ne sont pas physiques.";
                  }

                  variant.outerHTML +=
                    '<tr class="digital-product-warning"><td colspan="4"><div class="p-4 color-background-2"><i class="bi bi-info-circle me-2"></i> ' +
                    digitalWarning +
                    "</div></td></tr>";
                }
              });
            }
          });

          // Manage Alberta to Quebec
          if (
            document.querySelector(".gs__a-modal.gs__m-open") != null &&
            !hasAlreadyChanged
          ) {
            setTimeout(() => {
              var provinces = document.querySelector("#gsNewProvince").options;

              for (var i = 0; i < provinces.length; i++) {
                if (provinces[i].text == "Québec") {
                  provinces[i].selected = true;
                }
              }
            }, 300);

            hasAlreadyChanged = true;
          }

          if (document.querySelector(".gs__a-modal.gs__m-open") == null) {
            hasAlreadyChanged = false;
          }
        }, 10);
      });
  }

  /* ============================================================= */
  /* ============================================================= */
  /* ======================= Normal cart ========================= */
  /* ============================================================= */
  /* ============================================================= */

  setInterval(async () => {
    const box = document.querySelector("cart-items #gs__toggle-box");
    const cartItems = document.querySelector("cart-items");
    let activatedToggle = document.querySelector(".activated-toggle");

    if (box != null && cartItems != null && activatedToggle == null) {
      // Looking for bundles
      let hasBundles = false;

      // Looking for specific products
      let hasExcludedProducts = false;

      const cart = await fetch("/cart.json");
      const cartResponse = await cart.json();

      cartResponse.items.forEach((item) => {
        if (item.properties != null && item.properties._bundleParentId) {
          hasBundles = true;
        }

        if (excludedProducts.includes(item.sku)) {
          hasExcludedProducts = true;
        }
      });

      // create wrapper container
      let wrapper = document.createElement("div");
      wrapper.classList.add("activated-toggle", "mb-5");
      box.parentNode.insertBefore(wrapper, box);
      wrapper.appendChild(box);

      activatedToggle = document.querySelector(".activated-toggle");

      // Change notice first content
      activatedToggle.classList.add("color-background-2", "overflow-hidden");
      let notice =
        '<div class="toggle-action p-5 d-flex align-items-center justify-content-between gap-4" style="cursor: pointer;">';
      notice +=
        '<div class="d-flex align-items-center justify-content-start gap-4">';
      notice +=
        '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-truck-icon lucide-truck"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>';
      notice +=
        '<h2 class="mb-0">Souhaitez-vous livrer à plusieurs adresses?</h2>';
      notice += "</div>";
      notice += '<div class="d-flex align-items-center gap-4">';
      notice +=
        '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>';
      notice += "</div>";
      notice += "</div>";
      activatedToggle.insertAdjacentHTML("afterbegin", notice);

      // create another wrapper container
      wrapper = document.createElement("div");
      wrapper.classList.add("gs__align-left");
      box.parentNode.insertBefore(wrapper, box);
      wrapper.appendChild(box);

      // Change dropdown content
      activatedToggle.querySelector(".gs__align-left").style.maxHeight = "0";
      box.classList.add(
        "text-black",
        "bg-transparent",
        "w-100",
        "pt-0",
        "px-5",
        "pb-5",
      );
      const boxLabel = box.querySelector("label");
      boxLabel.classList.add(
        "float-none",
        "text-decoration-underline",
        "gs__toggle-switch",
      );
      boxLabel.innerHTML = "cliquer ici";

      const boxParagraph = box.querySelector("label");
      let before =
        '<div class="notice-warning d-flex align-items-start gap-4 bg-white p-4 border rounded mb-4">';
      before +=
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>';
      if (hasBundles || hasExcludedProducts) {
        before +=
          "<p class=\"lh-base\">Malheureusement, votre panier n'est pas compatible pour l'expédition à plusieurs adresses. <b>Les ensembles ne font pas partie de la fonctionnalité.</b></p>";
      } else {
        before +=
          '<p class="lh-base"><b>Bonne nouvelle!</b> Votre panier est compatible pour l\'expédition à plusieurs adresses.</p>';
      }
      before += "</div>";
      boxParagraph.insertAdjacentHTML("beforebegin", before);
      wrap(boxParagraph);
      before = "Veuillez ";
      boxParagraph.insertAdjacentHTML("beforebegin", before);

      let after = " pour activer cette option.";

      if (hasBundles || hasExcludedProducts) {
        after += "<style>.notice-warning + * { display: none; }</style>";
      }

      boxParagraph.insertAdjacentHTML("afterend", after);

      // Dropdown handle
      activatedToggle
        .querySelector(".toggle-action")
        .addEventListener("click", () => {
          if (
            activatedToggle.querySelector(".gs__align-left").style.maxHeight ==
            "0px"
          ) {
            activatedToggle.querySelector(".gs__align-left").style.maxHeight =
              "250px";
            activatedToggle.querySelector(
              ".lucide-chevron-down-icon",
            ).style.transform = "rotate(180deg)";
          } else {
            activatedToggle.querySelector(".gs__align-left").style.maxHeight =
              "0";
            activatedToggle.querySelector(
              ".lucide-chevron-down-icon",
            ).style.transform = "rotate(0)";
          }
        });
    }
  }, 500);
}

function wrap(toWrap, wrapper) {
  wrapper = wrapper || document.createElement("div");
  toWrap.parentNode.insertBefore(wrapper, toWrap);
  return wrapper.appendChild(toWrap);
}

// Masonry
window.addEventListener("resize", resizeAllMasonryItems);

// Tag selector
const selectTags = document.querySelector(".blog-tags-mobile");

if (selectTags != null) {
  selectTags.addEventListener("change", (e) => {
    window.location = e.target.value;
  });
}

function resizeMasonryItem(item) {
  const grid = document.getElementsByClassName("masonry")[0];
  const rowHeight = parseInt(
    window.getComputedStyle(grid).getPropertyValue("grid-auto-rows"),
  );
  const rowGap = parseInt(
    window.getComputedStyle(grid).getPropertyValue("grid-row-gap"),
  );
  const rowSpan = Math.ceil(
    (item.querySelector(".card__content").getBoundingClientRect().height +
      item.querySelector(".card__inner").getBoundingClientRect().height) /
      (rowHeight + rowGap),
  );
  item.style.gridRowEnd = "span " + rowSpan;
}

function resizeAllMasonryItems() {
  const allItems = document.querySelectorAll(".masonry-item");
  allItems.forEach((item) => {
    resizeMasonryItem(item);
  });
}

function resizeInstance(instance) {
  item = instance.elements[0];
  resizeMasonryItem(item);
}

// Recommended articles
if (document.querySelector(".article-template__recommended-articles") != null) {
  showRecommendedArticles();
}

async function showRecommendedArticles() {
  const recommended = JSON.parse(
    atob(
      document
        .querySelector(".recommended-articles__container")
        .getAttribute("data-articles"),
    ),
  );

  const fetchArticleCardHTML = (articleTileTemplateUrl) => {
    return fetch(articleTileTemplateUrl + "?view=card")
      .then((res) => res.text())
      .then((res) => {
        const text = res;
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(text, "text/html");
        const articleCard =
          htmlDocument.documentElement.querySelector(".card-wrapper");
        return '<div class="col">' + articleCard.outerHTML + "</div>";
      })
      .catch((err) =>
        console.error(
          `Failed to load content for url: ${articleTileTemplateUrl}`,
          err,
        ),
      );
  };

  const requests = recommended.map(fetchArticleCardHTML);
  const responses = await Promise.all(requests);
  const cardsHtml = responses.join("");
  document.querySelector(".recommended-articles__container").innerHTML =
    cardsHtml;

  resizeAllMasonryItems();
}

resizeAllMasonryItems();

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    resizeAllMasonryItems();
  }, 10);

  handleToggle();
});
